const SET_FEEDBACK_CLEAR = 'SET_FEEDBACK_CLEAR';
const SET_FEEDBACK_WORKING = 'SET_FEEDBACK_WORKING';
const SET_FEEDBACK_CONFIRMED = 'SET_FEEDBACK_CONFIRMED';

const initialState = {
  working: false,
  confirmed: null,
};

export default (previousState = initialState, { type, payload }) => {
  if (type === SET_FEEDBACK_CLEAR) {
    return initialState;
  }

  if (type === SET_FEEDBACK_WORKING) {
    return {
      ...previousState,
      working: payload,
    };
  }

  if (type === SET_FEEDBACK_CONFIRMED) {
    return {
      ...previousState,
      confirmed: payload,
    };
  }

  return previousState;
};

export const feedbackClear = (payload) => {
  return {
    type: SET_FEEDBACK_CLEAR,
    payload,
  };
};

export const feedbackWorking = (payload) => {
  return {
    type: SET_FEEDBACK_WORKING,
    payload,
  };
};

export const feedbackConfirmed = (payload) => {
  return {
    type: SET_FEEDBACK_CONFIRMED,
    payload,
  };
};
